import { useCallback } from 'react';
import { Box, Chip, Stack, Divider } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';

const prjTyps = [
  { id: 0, value: '', label: '전체', color: 'warning' },
  { id: 1, value: 'N', label: '프로젝트', color: 'info' },
  { id: 2, value: 'M', label: '유지보수', color: 'success' },
];

const chanceStatus = [
  { id: 0, value: '', label: '전체', color: 'warning' },
  { id: 1, value: '1', label: '기회확인', color: 'info' },
  { id: 2, value: '2', label: '기회분석', color: 'error' },
  { id: 3, value: '3', label: '매출견적', color: 'success' },
  { id: 4, value: '4', label: '수주품의 ', color: 'secondary' },
];

const ChanceStatusList = ({ filters, onFilters }) => {
  const handleFilterType = useCallback(
    (value) => {
      onFilters('searchPrjTyp', value);
    },
    [onFilters],
  );

  const handleFilterStatus = useCallback(
    (value) => {
      onFilters('searchGrade', value);
    },
    [onFilters],
  );

  return (
    <Box className="status-chip-list"
      sx={{
        display: 'flex',
        justifyContent: { xs: 'flex-start', md: 'flex-end' },
        alignItems: 'center',
        my: { xs: 1, md: 1 },
        mx: 0,
        width: '100%',
      }}
    >
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        divider={<Divider orientation="vertical" flexItem sx={{ display: { xs: 'none', md: 'block' } }} />}
        spacing={{ xs: 1, md: 2 }}
        sx={{ width: { xs: '100%', md: 'auto' } }}
      >
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
          {chanceStatus &&
            chanceStatus.map((st, index) => (
              <Chip
                sx={{ mr: 0 }}
                key={index}
                icon={<CircleIcon />}
                label={st.label}
                variant={
                  st.value === filters.searchGrade ? 'contained' : 'outlined'
                }
                color={st.color}
                onClick={() => handleFilterStatus(st.value)}
              />
            ))}
        </Box>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
          {prjTyps &&
            prjTyps.map((st, index) => (
              <Chip
                sx={{ mr: 0 }}
                key={index}
                icon={<CircleIcon />}
                label={st.label}
                variant={
                  st.value === filters.searchPrjTyp ? 'contained' : 'outlined'
                }
                color={st.color}
                onClick={() => handleFilterType(st.value)}
              />
            ))}
        </Box>
      </Stack>
    </Box>
  );
};

export default ChanceStatusList;
